import { render, staticRenderFns } from "./wapp.vue?vue&type=template&id=acf34558&scoped=true&"
import script from "./wapp.vue?vue&type=script&lang=js&"
export * from "./wapp.vue?vue&type=script&lang=js&"
import style0 from "./wapp.vue?vue&type=style&index=0&id=acf34558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf34558",
  null
  
)

export default component.exports